import React, { useEffect, useMemo, useState } from "react";
import PageContainer from "../../components/PageContainer/PageContainer";
import { useAccount, useBalance, useReadContract, useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import { formatUnits, parseUnits, zeroAddress } from "viem";
import BigcoinTokenContractABI from "../../abis/bigcointoken.abi.json";
import BigcoinMainContractABI from "../../abis/bigcoinmain.abi.json";
import { BIGCOINMAIN_ADDRESS, BIGCOINTOKEN_ADDRESS, CLAIM_SLIPPAGE, miners, RoomProperties, TOKEN_SYMBOL, TOTAL_BARNS } from "../../utils/constants";
import styled from "styled-components";
import Footer from "../../components/Footer";
import ConsoleImg from "../../assets/img/console.png";
import SImg from "../../assets/img/sonic.webp";
import BigImg from "../../assets/img/milk.png";
import GridImg from "../../assets/img/grid-button-blue.png";
import UpgradeImg from "../../assets/img/upgrade-button-blue.png";
import BuyButtonImg from "../../assets/img/buy_button.png";
import SellButtonImg from "../../assets/img/sell_button.png";
import SpaceImg from "../../assets/img/barns.png";
import EnergyImg from "../../assets/img/food1.webp";
import BuyFarmModal from "./components/BuyFarmModal";
import { useParams } from "react-router-dom";
import RoomCanvas from "./components/RoomCanvas";
import UpgradeSpaceModal from "./components/UpgradeSpaceModal";
import BuyMinerModal from "./components/BuyMinerModal";
import RemoveMinerModal from "./components/RemoveMinerModal";
import { notifyError, notifySuccess } from "../../hooks/utils";
import MobileControls from "./components/MobileControls";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

const OuterCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    gap: 12px;
    // width: 550px;
`;

const TabButton = styled.button<{ isActive: boolean }>`
    background: ${(props) => (props.isActive ? "#507c83" : "rgba(255, 255, 255, 0.05)")};
    color: ${(props) => (props.isActive ? "rgb(16, 44, 57)" : "rgb(160, 191, 195)")};
    border: none;
    padding: 8px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    font-family: Press Start 2P, cursive;
    font-size: 14px;
    text-transform: uppercase;
`;

const StatsTabButton = styled.button<{ isActive: boolean }>`
    font-size: 12px;
    color: ${(props) => (props.isActive ? "#507c83" : "rgb(208 215 232)")};
    cursor: pointer;
    transition: color 0.175s ease-in-out;
`;

const IconImg = styled.img`
    width: 32px;
    height: 32px;
`;

const StyledStatsText1 = styled.div`
    font-size: 14px;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 12px;
    color: rgb(220, 228, 228) !important;
`;

const StyledStatsText1Span = styled.span`
    color: #507c83;
    margin-left: 8px;
`;

const OuterGameBoardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: rgb(16, 44, 57);
    width: 770px;
    height: 640px;

    @media (max-width: 1024px) {
        aspect-ratio: 4/3;
        width: 100%;
        height: auto;
        margin-top: 40px;
    }
`;

const InnerGameBoardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 24px;
    flex: 1 1 0%;
`;

const GameTextNoBoard = styled.h1`
font-size: 22px;
    text-align: center;
    max-width: 90%;
    line-height: 1.4;
`;

const GameBoardImageContainer = styled.img`
    position: absolute;
    width: 860px;
    height: 700px;
    top: -24px;
    left: 0px;
    object-fit: contain;
    object-position: 0px 0px;
    pointer-events: none;
    z-index: 10;

    @media (max-width: 1024px) {
        aspect-ratio: 4/3;
        width: 100%;
        height: auto;
        object-fit: initial;
        top: 0px;
    }
`;

const BuyFacilityButton = styled.button`
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    font-family: inherit;
    background: rgb(16, 44, 57);
    color: #507c83;
    border: 2px solid #507c83;
    opacity: 1;
    transition: 0.2s ease-in-out, transform 0.1s ease-in-out;

    &:hover {
       background: rgb(26, 61, 79);
    }
`;

const SpacesOuterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: rgb(220, 228, 228);
`;
const SpacesUL = styled.ul`
    list-style-type: none;
    padding: 0px;
    margin: 0px 0px 8px;
    width: 100%;
    padding-top: 8px;
`;

const SpacesULRow = styled.li`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 6px 0px 6px 24px;
    line-height: 1.6;
    position: relative;
    color: rgb(220, 228, 228) !important;

    &:before {
        content: "-";
        position: absolute;
        left: 0px;
    }
`;

const SpacesUpgradeButton = styled.button`
    text-transform: uppercase;
    background-color: rgb(16, 44, 57);
    border: 2px solid #507c83;
    color: #507c83;
    padding: 8px 16px;
    cursor: pointer;
    font-family: inherit;
    align-self: center;
    font-size: 14px;

    &:hover {
       background: rgb(26, 61, 79);
    }
`;


const NoTileSelectedOuter = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

const TilesOuter = styled.div`
    min-height: 180px;
    // padding: 0px 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: rgb(220, 228, 228);
    `;

const TilesTextRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 8px 0px;
`;

const TileBuyRemoveMinerButton = styled.button`
text-transform: uppercase;
    background-color: rgb(16, 44, 57);
    border: 2px solid #507c83;
    color: #507c83;
    padding: 8px 16px;
    cursor: pointer;
    font-family: inherit;
    align-self: center;
    font-size: 14px;

        &:hover {
       background: rgb(26, 61, 79);
    }
`;

const GridButton = styled.img`
    position: absolute;
    bottom: 30px;
    left: 36px;
    width: 64px;
    height: 43px;
    cursor: pointer;
    transition: transform 0.1s ease-in-out;
    z-index: 11;

    &:hover {
        transform: scale(1.025);
    }

    @media (max-width: 650px) {
        display: none;
    }
`;

const UpgradeButton = styled.img`
    position: absolute;
    width: 94px;
    left: 104px;
    bottom: 30px;
    height: 43px;
    cursor: pointer;
    transition: transform 0.1s ease-in-out;
    z-index: 11;

    &:hover {
        transform: scale(1.025);
    }

    @media (max-width: 650px) {
        display: none;
    }
`;

const ClaimRewardsButton = styled.button`
    background: #507c83;
    color: rgb(16, 44, 57);
    border: none;
    padding: 10px 20px;
    font-family: Press Start 2P, cursive;
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s;

    &:hover:not(:disabled) {
        background: #24c7d6;
    }
`;

const IndividualGameInfoCardOuter = styled.div`
    border: 4px solid #507c83;
    width: 100%; 
`;

const IndividualGameInfoCardInner = styled.div`
    border: 2px solid rgb(14, 36, 93); 
    width: 100%; 
    background: rgb(16, 44, 57);
`;


const BuySellItemButton = styled.img`
    position: absolute;
    width: 64px;
    left: 200px;
    bottom: 30px;
    height: 43px;
    cursor: pointer;
    transition: transform 0.1s ease-in-out;
    z-index: 11;

    &:hover {
        transform: scale(1.025);
    }

    @media (max-width: 650px) {
        display: none;
    }
`;

const MainPage = () => {
    const { t, i18n } = useTranslation();
    const [userHasRoom, setUserHasRoom] = useState(true);

    const [mobileMenuActive, setMobileMenuActive] = useState(0);
    const isMobile = useMediaQuery("(max-width: 1024px)");

    const { wallet, id } = useParams<any>();
    const account = useAccount();

    const userAddress = useMemo(() => {
        if (wallet && wallet !== "undefined") {
            return wallet;
        }
        if (account && account.address) {
            return account.address;
        }
        return zeroAddress;
    }, [account]);

    const isUserViewingOtherWallet = useMemo(() => {
        if (wallet && account && account.address && wallet !== account.address) {
            return true;
        }
        return false;
    }, [account, wallet]);

    const userBalance = useBalance({
        address: userAddress,
    })


    const { data: animalsMustBeFed } = useReadContract({
        address: BIGCOINMAIN_ADDRESS,
        abi: BigcoinMainContractABI,
        functionName: 'animalsMustBeFed',
        args: []
    });

    const animalsMustBeFedFormatted = useMemo(() => {
        if (animalsMustBeFed && animalsMustBeFed === true) {
            return true;
        }
        return false;
    }, [animalsMustBeFed]);

    const { data: amountToPay } = useReadContract({
        address: BIGCOINMAIN_ADDRESS,
        abi: BigcoinMainContractABI,
        functionName: 'getAmountSonicForAnimalFeedersCorporation',
        args: [userAddress],
        query: { refetchInterval: 1000 },
    });

    const amountToPayFormatted = useMemo(() => {
        if (animalsMustBeFedFormatted) {
            if (amountToPay) {
                return Number(formatUnits(amountToPay as any, 18));
            }
        }
        return 0;
    }, [amountToPay, animalsMustBeFedFormatted]);

    // Add contract call for player miners
    const { data: playerMiners } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'getPlayerMinersPaginated',
        args: [userAddress, 0, 100], // Get up to 100 miners
        query: { refetchInterval: 1000 },
    });

    // Create state for miner positions
    const [minerPositions, setMinerPositions] = useState<{ [key: string]: any }>({});

    // Process miner data when it changes
    useEffect(() => {
        if (playerMiners) {
            const positions: { [key: string]: any } = {};
            (playerMiners as any[]).forEach((miner) => {
                // The miner data format from the contract call:
                // { facilityIndex, minerIndex, hashrate, id, inProduction, powerConsumption, x, y }
                const x = Number(miner.x);
                const y = Number(miner.y);
                // console.log('Processing miner at position:', x, y);
                positions[`${x},${y}`] = {
                    minerId: Number(miner.id),
                    // facilityIndex: Number(miner.facilityIndex),
                    minerIndex: Number(miner.minerIndex),
                    hashRate: Number(miner.hashrate),
                    powerUsage: Number(miner.powerConsumption),
                    isActive: miner.inProduction
                };
            });
            // console.log('Final minerPositions:', positions);
            setMinerPositions(positions);
        }
    }, [playerMiners]);

    const { data: bigTokenBalance } = useReadContract({
        address: BIGCOINTOKEN_ADDRESS,
        abi: BigcoinTokenContractABI,
        functionName: 'balanceOf',
        args: [userAddress as any]
    });

    const bigTokenBalanceFormatted = useMemo(() => {
        if (bigTokenBalance) {
            return Number(formatUnits(bigTokenBalance as any, 18)).toLocaleString("en-US", { maximumFractionDigits: 10 });
        }
        return "0.0000000000";
    }, [bigTokenBalance]);


    const { data: bigcoinTotalSupply } = useReadContract({
        address: BIGCOINTOKEN_ADDRESS,
        abi: BigcoinTokenContractABI,
        functionName: 'totalSupply',
        args: [],
        query: { refetchInterval: 1000 },
    });

    const { data: bigcoinTotalBurned } = useReadContract({
        abi: BigcoinTokenContractABI,
        address: BIGCOINTOKEN_ADDRESS,
        functionName: 'amtBurned',
        args: [],
        query: { refetchInterval: 1000 },
    });

    const bigcoinTotalBurnedFormatted = useMemo(() => {
        if (bigcoinTotalBurned) {
            return Number(formatUnits(bigcoinTotalBurned as any, 18)).toLocaleString("en-US", { maximumFractionDigits: 3 });
        }
        return "0.00";
    }, [bigcoinTotalBurned]);

    const totalBigcoinEverMintedFormatted = useMemo(() => {
        if (bigcoinTotalSupply && bigcoinTotalBurned) {
            return (Number(formatUnits(bigcoinTotalSupply as any, 18)) + Number(formatUnits(bigcoinTotalBurned as any, 18))).toLocaleString("en-US", { maximumFractionDigits: 3 });
        }
        return "0.00";
    }, [bigcoinTotalSupply, bigcoinTotalBurned]);


    const { data: bigcoinPerBlock } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'getMilkPerBlock',
        args: [],
        query: { refetchInterval: 1000 },
    });

    const bigcoinPerBlockFormatted = useMemo(() => {
        if (bigcoinPerBlock) {
            return Number(formatUnits(bigcoinPerBlock as any, 18)).toLocaleString("en-US", { maximumFractionDigits: 5 });
        }
        return "0.00";
    }, [bigcoinPerBlock]);


    const { data: userFarmPendingRewards } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'pendingRewards',
        args: [userAddress],
        query: { refetchInterval: 1000 },
    });

    const userFarmPendingRewardsFormatted = useMemo(() => {
        if (userFarmPendingRewards) {
            return Number(formatUnits(userFarmPendingRewards as any, 18)).toLocaleString("en-US", { maximumFractionDigits: 5 });
        }
        return "0.00";
    }, [userFarmPendingRewards]);

    const { data: playerHashRate } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'playerHashrate',
        args: [userAddress],
        query: { refetchInterval: 1000 },
    });

    const playerHashRateFormatted = useMemo(() => {
        if (playerHashRate) {
            return Number(formatUnits(playerHashRate as any, 0)).toLocaleString("en-US", { maximumFractionDigits: 0 });
        }
        return "0";
    }, [playerHashRate]);

    const { data: blocksUntilNextHalving } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'blocksUntilNextHalving',
        args: [],
        query: { refetchInterval: 1000 },
    });

    const blocksUntilNextHalvingFormatted = useMemo(() => {
        if (blocksUntilNextHalving) {
            return Number(formatUnits(blocksUntilNextHalving as any, 0)).toLocaleString("en-US", { maximumFractionDigits: 0 });
        }
        return "0";
    }, [blocksUntilNextHalving]);

    const { data: totalHashrate } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'totalHashrate',
        args: [],
        query: { refetchInterval: 1000 },
    });

    const totalHashrateFormatted = useMemo(() => {
        if (totalHashrate) {
            return Number(formatUnits(totalHashrate as any, 0)).toLocaleString("en-US", { maximumFractionDigits: 0 });
        }
        return "0";
    }, [totalHashrate]);

    const playerShareOfHashrateFormatted = useMemo(() => {
        if (totalHashrate && playerHashRate) {
            const playerShare = (Number(formatUnits(playerHashRate as any, 0)) / Number(formatUnits(totalHashrate as any, 0))) * 100;
            return playerShare.toLocaleString("en-US", { maximumFractionDigits: 6 });
        }
        return "0.000000";
    }, [totalHashrate, playerHashRate]);

    const playerRoomRewardsPerDayFormatted = useMemo(() => {
        if (bigcoinPerBlock && totalHashrate && playerHashRate) {
            const rewardsPerDay = Number(formatUnits(bigcoinPerBlock as any, 18)) * 3 * 24 * 60 * 60;
            const playerShareUnformatted = (Number(formatUnits(playerHashRate as any, 0)) / Number(formatUnits(totalHashrate as any, 0))) * 100;
            const playerShare = Number(playerShareUnformatted) / 100;
            return (rewardsPerDay * playerShare).toLocaleString("en-US");
        }
        return "0";
    }, [bigcoinPerBlock]);

    // facilityIndex   uint256 :  1
    // maxMiners   uint256 :  4
    // currMiners   uint256 :  1
    // totalPowerOutput   uint256 :  28
    // currPowerOutput   uint256 :  1
    // x   uint256 :  2
    // y   uint256 :  2
    const { data: playerRoomInfo } = useReadContract({
        abi: BigcoinMainContractABI,
        address: BIGCOINMAIN_ADDRESS,
        functionName: 'ownerToFacility',
        args: [userAddress],
        query: { refetchInterval: 1000 },
    });

    // console.log("Player Room Info:", playerRoomInfo);

    const playerRoomTotalSpacesFormatted = useMemo(() => {
        if (playerRoomInfo) {
            return Number((playerRoomInfo as any)[1].toString());
        }
        return "0";
    }, [playerRoomInfo]);

    const playerRoomTotalGigawattsFormatted = useMemo(() => {
        if (playerRoomInfo) {
            return Number((playerRoomInfo as any)[3].toString());
        }
        return "0";
    }, [playerRoomInfo]);

    const playerRoomSpacesLeftFormatted = useMemo(() => {
        if (playerRoomInfo) {
            return Number((playerRoomInfo as any)[1].toString()) - Number((playerRoomInfo as any)[2].toString());
        }
        return 0;
    }, [playerRoomInfo]);

    const playerRoomGigawattsAvailableFormatted = useMemo(() => {
        if (playerRoomInfo) {
            return Number((playerRoomInfo as any)[3].toString()) - Number((playerRoomInfo as any)[4].toString());
        }
        return 0;
    }, [playerRoomInfo]);

    const currentPlayerRoomLevel = useMemo(() => {
        if (playerRoomInfo) {
            const playerRoomLevel = Number((playerRoomInfo as any)[0].toString())
            if (playerRoomLevel > 0) {
                setUserHasRoom(true);
                return playerRoomLevel;
            } else {
                setUserHasRoom(false);
                return 1;
            }
        }
        return 1;
    }, [playerRoomInfo]);

    const [tabSelected, setTabSelected] = useState("stats");
    const [statsSelected, setStatsSelected] = useState(0);

    const [showBuyFarmModal, setShowBuyFarmModal] = useState(false);
    const [showUpgradeSpaceModal, setShowUpgradeSpaceModal] = useState(false);

    const [hasTileSelected, setHasTileSelected] = useState(false);
    const [tileSelectedHasMiner, setTileSelectedHasMiner] = useState(false);
    const [selectedTilePosition, setSelectedTilePosition] = useState<{ x: number, y: number } | null>(null);

    const [showBuyMinerModal, setShowBuyMinerModal] = useState(false);
    const [selectedBuyTile, setSelectedBuyTile] = useState<{ x: number, y: number } | null>(null);

    const [showRemoveMinerModal, setShowRemoveMinerModal] = useState(false);

    const [gridEnabled, setGridEnabled] = useState(true);

    // Update tile info when selection changes
    useEffect(() => {
        if (selectedTilePosition) {
            setHasTileSelected(true);
            const minerIndex = minerPositions[`${selectedTilePosition.x},${selectedTilePosition.y}`]?.minerIndex;
            const minerObj = miners.find(m => m.id === minerIndex);
            const minerId = minerPositions[`${selectedTilePosition.x},${selectedTilePosition.y}`]?.minerId ?? 0;
            setTileSelectedHasMiner(minerObj !== undefined);
        } else {
            setHasTileSelected(false);
            setTileSelectedHasMiner(false);
        }
    }, [selectedTilePosition, minerPositions]);

    const handleTileSelect = (x: number, y: number) => {
        if (selectedTilePosition && selectedTilePosition.x === x && selectedTilePosition.y === y) {
            // Deselect the tile if it's already selected
            setSelectedTilePosition(null);
            setHasTileSelected(false);
            setTileSelectedHasMiner(false);
            setTabSelected("tiles");
        }
        else {
            setSelectedTilePosition({ x, y });
            setTabSelected("tiles");
        }
        // Do NOT open BuyMinerModal here
    };

    const [claimingRewards, setClaimingRewards] = useState(false);

    const { data: hash, error, isPending, writeContract } = useWriteContract();
    const { isLoading: isConfirming, isSuccess: isConfirmed } = useWaitForTransactionReceipt({
        hash,
    });

    // Log the transaction arguments and hash for debugging
    useEffect(() => {
        if (hash) {
            notifySuccess("Claiming Rewards");
        }
        if (error) {
            notifyError("An error occurred while trying to claim rewards.");
        }
        if (isConfirmed) {
            notifySuccess("Claimed Rewards!");
        }
    }, [hash, error]);


    const handleClaimRewards = async () => {
        if (!account) {
            notifyError("You need to connect wallet first.");
            return;
        }

        try {
            setClaimingRewards(true);

            const transactionArgs = {
                abi: BigcoinMainContractABI,
                address: BIGCOINMAIN_ADDRESS,
                functionName: 'claimRewards',
                args: [],
                value: amountToPayFormatted > 0 ? parseUnits((amountToPayFormatted * CLAIM_SLIPPAGE).toFixed(18), 18) : 0,
            };

            writeContract(transactionArgs as any);
        } catch (error) {
            notifyError("An error occurred while trying to claim rewards.");
        } finally {
            setClaimingRewards(false);
        }
    };

    return (
        <PageContainer>
            {showBuyFarmModal && (
                <BuyFarmModal open={showBuyFarmModal} onClose={() => setShowBuyFarmModal(false)} />
            )}
            {showUpgradeSpaceModal && (
                <UpgradeSpaceModal
                    open={showUpgradeSpaceModal}
                    onClose={() => setShowUpgradeSpaceModal(false)}
                    currentRoom={RoomProperties[currentPlayerRoomLevel]}
                    nextRoom={RoomProperties[currentPlayerRoomLevel + 1]}
                />
            )}
            {showBuyMinerModal && (
                <BuyMinerModal
                    open={showBuyMinerModal}
                    onClose={() => setShowBuyMinerModal(false)}
                    selectedPosition={selectedBuyTile}
                    availableEnergy={playerRoomGigawattsAvailableFormatted}
                />
            )}
            {showRemoveMinerModal &&
                minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`] &&
                miners.find(m => m.id === minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.minerIndex) && (
                    <RemoveMinerModal
                        open={showRemoveMinerModal}
                        onClose={() => setShowRemoveMinerModal(false)}
                        miner={{
                            position: {
                                x: selectedTilePosition ? selectedTilePosition.x : 0,
                                y: selectedTilePosition ? selectedTilePosition.y : 0
                            },
                            miner: miners.find(m => m.id === minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.minerIndex)!,
                            minerId: minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.minerId ?? 0
                        }}
                    />
                )}
            <main className="h-full" style={{ minHeight: '100vh', color: '#fff', fontFamily: "Undead Pixel 11, ui-sans-serif" }}>

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: isMobile ? "100%" : "calc(-24px + 100vh)", }}>
                    {isUserViewingOtherWallet && (
                        <div style={{ 
                            background: "rgb(26, 61, 79)", 
                            border: "2px solid rgb(42, 77, 95)",
                            width: "100%",
                            maxWidth: "calc(100% - 50px)",
                            padding: "10px",
                            marginBottom: "40px",
                            marginTop: "40px",
                        }}>{t("main.game.viewing_other_player")}</div>
                    )}

                    <OuterInfoAndGameContainer>
                        <OuterCardContainer style={{ width: isMobile ? "100%" : "550px" }}>
                            <IndividualGameInfoCardOuter style={{ display: isMobile ? mobileMenuActive === 0 ? "flex" : "none" : "flex" }}>
                                <IndividualGameInfoCardInner>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", minHeight: "232px", width: "100%", padding: "10px" }}>
                                        <div className="sc-a50e4e8d-2 lhjOhw">
                                            <TabButton isActive={tabSelected === "stats"} onClick={() => setTabSelected("stats")}>{t("main.infos.tab.resources")}</TabButton>
                                            <TabButton isActive={tabSelected === "spaces"} onClick={() => setTabSelected("spaces")}>{t("main.infos.tab.spaces")}</TabButton>
                                            <TabButton isActive={tabSelected === "tiles"} onClick={() => setTabSelected("tiles")}>{t("main.infos.tab.tiles")}</TabButton>
                                        </div>
                                        {tabSelected === "stats" && (
                                            <div style={{ flex: "1 1 0%", overflowY: "auto", width: "100%" }}>
                                                <div
                                                    style={{ paddingTop: 6, gap: 8, display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", height: "100%", width: "100%", fontSize: "14px", color: "rgb(220, 228, 228)" }}
                                                >
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "1.6px 0px" }}>
                                                        <IconImg
                                                            src={SImg}
                                                            alt="S"
                                                            style={{ padding: "7px" }}
                                                        />
                                                        <span className="sc-7ad2b83c-3 glpSkS">{userBalance ? Number(formatUnits(userBalance.data ? userBalance.data.value.toString() : "0.00000" as any, 18)).toFixed(5) : "0.00000"}</span>
                                                        <span style={{ marginLeft: "12px" }}>S</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "1.6px 0px" }}>
                                                        <IconImg
                                                            src={BigImg}
                                                            alt={TOKEN_SYMBOL}
                                                        />
                                                        <span className="sc-7ad2b83c-3 glpSkS">{bigTokenBalanceFormatted}</span>
                                                        <span style={{ marginLeft: "12px" }}>{TOKEN_SYMBOL}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "1.6px 0px" }}>
                                                        <IconImg
                                                            src={SpaceImg}
                                                            alt="SPACES LEFT"
                                                            style={{ padding: "4px" }}
                                                        />
                                                        <span className="sc-7ad2b83c-3 glpSkS">{playerRoomSpacesLeftFormatted}</span>
                                                        <span style={{ marginLeft: "12px" }}>{t("main.infos.spaces_available")}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "1.6px 0px" }}>
                                                        <IconImg
                                                            src={EnergyImg}
                                                            alt="GIGAWATTS AVAILABLE"
                                                            style={{ padding: "4px" }}
                                                        />
                                                        <span className="sc-7ad2b83c-3 glpSkS">{playerRoomGigawattsAvailableFormatted}</span>
                                                        <span style={{ marginLeft: "12px" }}>
                                                            {t("main.infos.food_available")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {tabSelected === "spaces" && (
                                            <SpacesOuterContainer>
                                                <SpacesUL>
                                                    <SpacesULRow>Your {RoomProperties[currentPlayerRoomLevel].name}</SpacesULRow>
                                                    <SpacesULRow>{playerRoomTotalSpacesFormatted} {t("main.infos.total_spaces")}</SpacesULRow>
                                                    <SpacesULRow>{playerRoomTotalGigawattsFormatted} {t("main.infos.total_food")}</SpacesULRow>
                                                    <SpacesULRow>{RoomProperties[currentPlayerRoomLevel].description}</SpacesULRow>
                                                </SpacesUL>
                                                <SpacesUpgradeButton disabled={currentPlayerRoomLevel === TOTAL_BARNS} style={{cursor: currentPlayerRoomLevel === TOTAL_BARNS ? "not-allowed" : "pointer"}} onClick={() => setShowUpgradeSpaceModal(true)}>{t("main.infos.upgrade")}</SpacesUpgradeButton>
                                            </SpacesOuterContainer>
                                        )}

                                        {tabSelected === "tiles" && (
                                            <div style={{ width: "100%", transition: "box-shadow 0.225s ease-in-out", borderRadius: "6px" }}>
                                                <TilesOuter>
                                                    {hasTileSelected ? (
                                                        <TilesOuter>
                                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch", gap: "4px", marginBottom: "16px", flexGrow: 1, paddingTop: "8px" }}>
                                                                <TilesTextRow>
                                                                    <span style={{ fontWeight: "bold", color: "rgb(136, 136, 136)" }}>{t("main.infos.position")}:</span>
                                                                    <span style={{ flexGrow: 1, textAlign: "left" }}>X: {selectedTilePosition?.x ?? 0}, Y: {selectedTilePosition?.y ?? 0}</span>
                                                                </TilesTextRow>
                                                                <TilesTextRow>
                                                                    <span style={{ fontWeight: "bold", color: "rgb(136, 136, 136)" }}>{t("main.infos.item")}:</span>
                                                                    <span style={{ flexGrow: 1, textAlign: "left" }}>
                                                                        {tileSelectedHasMiner
                                                                            ? (
                                                                                (() => {
                                                                                    const minerIndex = minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.minerIndex;
                                                                                    const minerObj = miners.find(m => m.id === minerIndex);
                                                                                    return minerObj ? minerObj.name : "UNKNOWN MINER";
                                                                                })()
                                                                            )
                                                                            : "NO ITEM"}
                                                                    </span>
                                                                </TilesTextRow>
                                                                {tileSelectedHasMiner && (<>
                                                                    <TilesTextRow>
                                                                        <span style={{ fontWeight: "bold", color: "rgb(136, 136, 136)" }}>{t("main.infos.milk_power")}:</span>
                                                                        <span style={{ flexGrow: 1, textAlign: "left" }}>
                                                                            {minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.hashRate ?? 0} L/s
                                                                        </span>
                                                                    </TilesTextRow>
                                                                    <TilesTextRow>
                                                                        <span style={{ fontWeight: "bold", color: "rgb(136, 136, 136)" }}>{t("main.infos.food")}:</span>
                                                                        <span style={{ flexGrow: 1, textAlign: "left" }}>
                                                                            {minerPositions[`${selectedTilePosition?.x},${selectedTilePosition?.y}`]?.powerUsage ?? 0} {t("main.infos.food")}
                                                                        </span>
                                                                    </TilesTextRow>
                                                                </>)}
                                                            </div>
                                                            <div className="sc-c428fdcc-6 dwEpRD" style={{ marginTop: "auto" }}>
                                                                <TileBuyRemoveMinerButton
                                                                    onClick={() => {
                                                                        if (tileSelectedHasMiner && selectedTilePosition) {
                                                                            const miner = minerPositions[`${selectedTilePosition.x},${selectedTilePosition.y}`];
                                                                            setShowRemoveMinerModal(true);
                                                                        } else if (!tileSelectedHasMiner && selectedTilePosition) {
                                                                            setSelectedBuyTile(selectedTilePosition);
                                                                            setShowBuyMinerModal(true);
                                                                        }
                                                                    }}
                                                                    disabled={!hasTileSelected}
                                                                >
                                                                    {tileSelectedHasMiner ? t("main.infos.remove_item") : t("main.infos.buy_item")}
                                                                </TileBuyRemoveMinerButton>
                                                            </div>
                                                        </TilesOuter>
                                                    ) : (
                                                        <TilesOuter style={{ justifyContent: "center" }}>
                                                            <NoTileSelectedOuter>
                                                                <div
                                                                    className="sc-c428fdcc-3 vkhOx"
                                                                    style={{ flexGrow: 1, width: "100%", textAlign: "center" }}
                                                                >
                                                                    <span className="sc-c428fdcc-5 jqapnN" style={{ flexGrow: 1 }}>[{t("main.infos.no_tile_selected")}]</span>
                                                                </div>
                                                            </NoTileSelectedOuter>
                                                        </TilesOuter>
                                                    )}
                                                </TilesOuter>
                                            </div>
                                        )}

                                    </div>
                                </IndividualGameInfoCardInner>
                            </IndividualGameInfoCardOuter>
                            <IndividualGameInfoCardOuter style={{ display: isMobile ? mobileMenuActive === 1 ? "flex" : "none" : "flex" }}>
                                <IndividualGameInfoCardInner>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", minHeight: "232px", width: "100%", padding: "10px" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginBottom: "24px" }}>
                                            <h3 style={{ fontSize: "16px", color: "rgb(220, 228, 228)" }}>{t("main.infos.stats")}</h3>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "12px" }}>
                                                <StatsTabButton isActive={statsSelected === 0} onClick={() => setStatsSelected(0)}>{t("main.infos.simple")}</StatsTabButton>
                                                <h3 style={{ fontSize: "16px", color: "rgb(220, 228, 228)" }}>/</h3>
                                                <StatsTabButton isActive={statsSelected === 1} onClick={() => setStatsSelected(1)}>{t("main.infos.pro")}</StatsTabButton>
                                            </div>
                                        </div>

                                        {statsSelected === 0 && (
                                            <>
                                                <StyledStatsText1>
                                                    - {t("main.infos.simple.info_1_p1")}<StyledStatsText1Span>{playerRoomRewardsPerDayFormatted} {TOKEN_SYMBOL}</StyledStatsText1Span>{t("main.infos.simple.info_1_p2")}
                                                </StyledStatsText1>
                                                <StyledStatsText1>
                                                    - {t("main.infos.simple.info_2_p1")}<StyledStatsText1Span>{playerHashRateFormatted} L/s</StyledStatsText1Span>
                                                </StyledStatsText1>
                                                <StyledStatsText1>
                                                    -
                                                    <StyledStatsText1Span style={{ marginRight: 8 }}>
                                                        {blocksUntilNextHalvingFormatted} {t("main.infos.simple.info_3_p1")}
                                                    </StyledStatsText1Span>
                                                    {t("main.infos.simple.info_3_p2")}
                                                </StyledStatsText1>
                                                <StyledStatsText1>
                                                    - {t("main.infos.simple.info_4_p1")}<StyledStatsText1Span>{playerShareOfHashrateFormatted}%</StyledStatsText1Span> {t("main.infos.simple.info_4_p2")}
                                                    <StyledStatsText1Span>({totalHashrateFormatted} L/s)</StyledStatsText1Span>
                                                </StyledStatsText1>
                                            </>
                                        )}
                                        {statsSelected === 1 && (
                                            <>
                                                <StyledStatsText1>
                                                    - <StyledStatsText1Span>{bigcoinPerBlockFormatted} {t("main.infos.pro.info_1_p1")} {TOKEN_SYMBOL}</StyledStatsText1Span>{" "}
                                                    {t("main.infos.pro.info_1_p2")}
                                                </StyledStatsText1>
                                                <StyledStatsText1>
                                                    -
                                                    <StyledStatsText1Span>
                                                        {totalBigcoinEverMintedFormatted} ${TOKEN_SYMBOL}
                                                    </StyledStatsText1Span>{" "}
                                                    {t("main.infos.pro.info_2_p1")}
                                                </StyledStatsText1>
                                                <StyledStatsText1>
                                                    -
                                                    <StyledStatsText1Span>
                                                        {bigcoinTotalBurnedFormatted} ${TOKEN_SYMBOL}
                                                    </StyledStatsText1Span>{" "}
                                                    {t("main.infos.pro.info_3_p1")}
                                                </StyledStatsText1>
                                            </>
                                        )}
                                    </div>
                                </IndividualGameInfoCardInner>
                            </IndividualGameInfoCardOuter>
                            <IndividualGameInfoCardOuter style={{ display: isMobile ? mobileMenuActive === 2 ? "flex" : "none" : "flex" }}>
                                <IndividualGameInfoCardInner>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", minHeight: "100px", width: "100%", padding: "10px" }}>
                                        <div style={{ fontSize: "14px", color: "rgb(220, 228, 228)", textAlign: "center", lineHeight: "2", marginBottom: "12px", marginTop: "8px", width: "100%" }}>
                                            {t("main.claim_section.title")}
                                            <span className="sc-4393d1ae-3 cLgIgc">
                                                {" "}
                                                {userFarmPendingRewardsFormatted !== "0.00" ? (
                                                    <span
                                                        style={{
                                                            color: "#507c83",
                                                            display: "inline-block",
                                                            transform: "scale(1.3)",
                                                            filter: "brightness(1.25)",
                                                            textShadow: "rgb(136 171 250 / 40%) 0px 0px 10px",
                                                            fontWeight: "bold",
                                                            paddingLeft: "20px",
                                                            paddingRight: "20px",
                                                            transition: "0.2s"
                                                        }}>
                                                        {userFarmPendingRewardsFormatted}
                                                    </span>
                                                ) : (
                                                    <span
                                                        style={{
                                                            color: "#507c83",
                                                            display: "inline-block",
                                                            transform: "scale(1)",
                                                            filter: "brightness(1)",
                                                            textShadow: "rgba(237, 250, 136, 0) 0px 0px 0px",
                                                            fontWeight: "bold",
                                                            paddingLeft: "20px",
                                                            paddingRight: "20px",
                                                            transition: "0.2s"
                                                        }}
                                                    >
                                                        0
                                                    </span>
                                                )}
                                                {" "}
                                                ${TOKEN_SYMBOL}
                                            </span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%" }}>
                                            <ClaimRewardsButton onClick={handleClaimRewards} disabled={claimingRewards || isPending || isConfirming || isUserViewingOtherWallet} style={{ cursor: claimingRewards || isPending || isConfirming || isUserViewingOtherWallet ? "not-allowed" : "pointer" }}>
                                                {(claimingRewards || isPending || isConfirming) ? t("main.claim_section.claim_btn.claiming") : t("main.claim_section.claim_btn.claim")}
                                            </ClaimRewardsButton>
                                        </div>
                                        {animalsMustBeFedFormatted && (
                                            <div style={{ fontSize: "11px", color: "rgb(220, 228, 228)", textAlign: "center", lineHeight: "2", marginBottom: "12px", marginTop: "8px", width: "100%" }}>
                                                {t("main.claim_section.fee_info_p1")} {amountToPayFormatted.toLocaleString("en-US", { maximumSignificantDigits: 2 })} {t("main.claim_section.fee_info_p2")}
                                            </div>
                                        )}

                                    </div>
                                </IndividualGameInfoCardInner>
                            </IndividualGameInfoCardOuter>
                        </OuterCardContainer>
                        {userHasRoom && (
                            <OuterGameBoardContainer>
                                <RoomCanvasOuterContainer style={{ overflow: "hidden", pointerEvents: "auto", paddingBottom: "16px", width: "100%" }}>
                                    <RoomCanvas
                                        facilityIndex={currentPlayerRoomLevel}
                                        minerPositions={minerPositions}
                                        onTileSelect={handleTileSelect}
                                        gridEnabled={gridEnabled}
                                    />
                                </RoomCanvasOuterContainer>
                                <GridButton src={GridImg} onClick={() => setGridEnabled(!gridEnabled)}></GridButton>
                                <UpgradeButton onClick={() => currentPlayerRoomLevel === TOTAL_BARNS ? null : setShowUpgradeSpaceModal(true)} src={UpgradeImg} style={{opacity: currentPlayerRoomLevel === TOTAL_BARNS ? "0.5" : "1", cursor: currentPlayerRoomLevel === TOTAL_BARNS ? "not-allowed" : "pointer"}}></UpgradeButton>

                                <BuySellItemButton
                                    onClick={() => {
                                        if (tileSelectedHasMiner && selectedTilePosition) {
                                            const miner = minerPositions[`${selectedTilePosition.x},${selectedTilePosition.y}`];
                                            setShowRemoveMinerModal(true);
                                        } else if (!tileSelectedHasMiner && selectedTilePosition) {
                                            setSelectedBuyTile(selectedTilePosition);
                                            setShowBuyMinerModal(true);
                                        }
                                    }}
                                    style={{ display: hasTileSelected ? "flex" : "none" }}
                                    src={(tileSelectedHasMiner && selectedTilePosition) ? SellButtonImg : (!tileSelectedHasMiner && selectedTilePosition) ? BuyButtonImg : BuyButtonImg}
                                >
                                </BuySellItemButton>
                                <GameBoardImageContainer src={ConsoleImg} />
                            </OuterGameBoardContainer>
                        )}
                        {!userHasRoom && (
                            <OuterGameBoardContainer>
                                <InnerGameBoardContainer>
                                    <GameTextNoBoard>{t("main.game.no_barn")}</GameTextNoBoard>
                                    <BuyFacilityButton onClick={() => setShowBuyFarmModal(true)}>{t("main.game.buy_barn")}</BuyFacilityButton>
                                </InnerGameBoardContainer>
                                <GameBoardImageContainer src={ConsoleImg} />
                            </OuterGameBoardContainer>
                        )}
                        <MobileControls
                            setMobileMenuActive={setMobileMenuActive}
                            mobileMenuActive={mobileMenuActive}
                            isMobile={isMobile}
                        />
                    </OuterInfoAndGameContainer>
                </div>

            </main>
            <Footer />
        </PageContainer>
    );
}

const RoomCanvasOuterContainer = styled.div`
    @media (max-width: 1024px) {
        aspect-ratio: 4 / 3;
        padding-bottom: 0px;
    }
`;

const OuterInfoAndGameContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    width: 100%;
    max-width: 1520px;

    // @media (max-width: 1380px) and (min-width: 650px) {
    //     transform: scale(0.75);
    //     width: 125%;
    // }

    @media (max-width: 1024px) {
        flex-direction: column;
        justify-content: space-between;
        padding: 72px 0px;

        transform: scale(1);
        width: 100%;
    }
`;

export default MainPage;
